
export default{
  login:'/sys/authc/login',
  logout:'/sys/authc/logout',
  getMenu:"/sys/authc/menuresource",//获取资源
  modifyPwd:"/sys/authc/alterpassword",//修改密码
  drawImage:"/drawImage"//验证码管理-生成验证码
}
